"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  APP_NAME: true,
  PACKAGE_NAME: true,
  EMOTION_CACHE_KEY: true,
  TEAM_NAME: true
};
exports.PACKAGE_NAME = exports.EMOTION_CACHE_KEY = exports.APP_NAME = void 0;
Object.defineProperty(exports, "TEAM_NAME", {
  enumerable: true,
  get: function () {
    return _constantsGenerated.TEAM_NAME;
  }
});
var _defaultTranslations = require("./defaultTranslations");
Object.keys(_defaultTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _defaultTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _defaultTranslations[key];
    }
  });
});
var _constantsGenerated = require("../constants-generated");
const APP_NAME = exports.APP_NAME = 'loyalty-dialog';
const PACKAGE_NAME = exports.PACKAGE_NAME = '@ori/loyalty-dialog';
const EMOTION_CACHE_KEY = exports.EMOTION_CACHE_KEY = `${APP_NAME}-emotion-cache-key`;
